<template>
  <div>
    Component settings detail language
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import Base from "../../base/Base.vue";
@Options({})
export default class Language extends Base {}
</script>
